import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Spinner,
  Table,
} from 'react-bootstrap';
import { updateSelectedContextAction } from '../../../actions/instances/context';
import CreateSelectModal from '../../Modals/CreateSelectModal/CreateSelectModal';
import CreateContextModal from '../../Modals/Content/Contexts/CreateContextModal/CreateContextModal';
import SelectContextModal from '../../Modals/Content/Contexts/SelectContextModal/SelectContextModal';
import './ContextsList.scss';
import DeleteButton from '../../atoms/DeleteButton/DeleteButton';
import Api from '../../../services/Api';

const ContextsList = ({
  contexts,
  onItemAdded,
  isLoading,
  cityId,
  dynastyId,
  buildingId,
  loadMetadata,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [contextsInlineEditingShown, setContextsInlineEditingShown] = useState(false);
  const navigateToComponent = (context) => {
    dispatch(updateSelectedContextAction(context));
    history.push('/instances/building-contexts/view');
  };
  const deleteCxontext = async (con) => {
    const ids = contexts.filter(c => c.id !== con.id).map(c => c.id);
    console.log('Delete context', ids);
    await Api.patch(`instances/buildings/${buildingId}`, {
      contexts_ids: [...ids],
    });
    await loadMetadata();
  };
  const itemSelected = (context) => {
    if (onItemAdded) {
      onItemAdded(context);
    }
    setContextsInlineEditingShown(false);
  };
  return (
    <div className="row mt-5">
      <div className="col-md-12 d-flex justify-content-between">
        <h6 className="ps-0">Contexts</h6>
        <p>
          <CreateSelectModal
            title="Create or select a context"
            createView={(
              <CreateContextModal
                onItemCreated={comp => itemSelected(comp)}
                cityId={cityId}
                dynastyId={dynastyId}
              />
            )}
            selectView={<SelectContextModal onItemSelected={comp => itemSelected(comp)} />}
            onRequestClose={() => setContextsInlineEditingShown(false)}
            isShown={contextsInlineEditingShown}
          />
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a href="#" onClick={() => setContextsInlineEditingShown(true)}>
            Link to Context
          </a>
        </p>
      </div>
      <div className="col-md-12">
        <Table striped bordered hover>
          <colgroup>
            <col width="10%" />
            <col width="70%" />
            <col width="20%" />
          </colgroup>
          <thead>
            <tr>
              <th />
              <th>Name</th>
              <th>Dynasty</th>
              <th>Unlink</th>
            </tr>
          </thead>
          <tbody>
            {!isLoading && contexts && contexts.map(con => (
              <tr>
                <td>
                  {con.images.length > 0 ? (
                    <img alt={con.name} src={con.images[0].url} height={50} width={50} style={{ objectFit: 'cover' }} />
                  ) : (
                    <img alt={con.name} src="/images/default.jpg" height={50} width={50} style={{ objectFit: 'cover' }} />
                  )}
                </td>
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                <td onClick={() => navigateToComponent(con)}>
                  {`${con.name} [${con.code}]`}
                </td>
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                <td onClick={() => history.push('/dynasties')}>
                  {`${con.dynasty.name} [${con.dynasty.code}]`}
                </td>
                <td>
                  <DeleteButton
                    onInvoked={() => deleteCxontext(con)}
                  />
                  {/* X */}
                  {/* X */}
                </td>
              </tr>
            ))}
            {!isLoading && (contexts === undefined || contexts.length === 0) && (
            <tr className="text-center">
              <td colSpan={3}>No Components were added to this building</td>
            </tr>
            )}
            {isLoading && (
              <tr>
                <td colSpan={3} className="text-center">
                  <Spinner />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

ContextsList.propTypes = {
  contexts: PropTypes.array.isRequired,
  onItemAdded: PropTypes.func,
  loadMetadata: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  cityId: PropTypes.number,
  dynastyId: PropTypes.number,
  buildingId: PropTypes.number.isRequired,
};

ContextsList.defaultProps = {
  onItemAdded: undefined,
  isLoading: false,
  cityId: undefined,
  dynastyId: undefined,
};

export default ContextsList;
